import T from 'utils/T';
import ex from 'utils/ex';
import './Section.css';
import React from 'react';

// 의미적인 분리
export default React.forwardRef(function Section(props, ref) {
  const {
    caption,
    options,
    direction, // DIRECTION_HORIZONTAL | DIRECTION_VERTICAL
    children,
    fullunset,
    ...rest
  } = props || {};
  return (
    <div
      {...ex(['Section', { fullunset }], rest)}
      {...{ ref }}
    >
      <div {...ex('SectionHeader')} >
        <div {...ex('SectionCaption')} >
          {caption}
        </div>
        <div {...ex('SectionOptions')} >
          {options}
        </div>
      </div>
      <div {...ex(['SectionBody', direction])}>
        {children}
      </div>
    </div>
  );
});
